/* EV Tech Spot · stars on product cards (02.11.2026): fill once when the card comes into view.
   One IntersectionObserver for all cards; cards added later (filters, related products) are picked up by a
   MutationObserver. With reduced motion the CSS shows the stars filled and this script does nothing. */
(function () {
  'use strict';
  if (window.__evtsStars) return;
  window.__evtsStars = true;
  document.documentElement.classList.add('evts-stars-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  if (!('IntersectionObserver' in window)) {
    document.documentElement.classList.remove('evts-stars-js');   // CSS fallback fills them
    return;
  }
  var batch = 0;
  var io = new IntersectionObserver(function (entries) {
    var shown = 0;
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      // Cards that come in together fill one after another (60 ms apart).
      e.target.style.setProperty('--evts-d', (shown++ * 0.06).toFixed(2) + 's');
      e.target.classList.add('is-in');
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.2 });
  function scan() {
    batch = 0;
    var els = document.querySelectorAll('.evts-stars:not([data-evts-seen])');
    for (var i = 0; i < els.length; i++) { els[i].setAttribute('data-evts-seen', ''); io.observe(els[i]); }
  }
  scan();
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (batch) return;
      batch = requestAnimationFrame(scan);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
